export default "__VITE_ASSET__GkRnj2bu__"